import { render } from "./ButtonRank1.vue?vue&type=template&id=1379d336&scoped=true"
import script from "./ButtonRank1.vue?vue&type=script&lang=js"
export * from "./ButtonRank1.vue?vue&type=script&lang=js"

import "./ButtonRank1.vue?vue&type=style&index=0&id=1379d336&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1379d336"]])

export default __exports__